import React, { useContext, useState } from 'react';
import {
  DropdownOption,
  Dropdown,
  Button,
  TextInput,
  TableRow,
  TableCell,
  Icon,
} from '@vp/swan';
import { PageModsContext } from '../../contexts/PageModsContext';
import {
  ITEM_SCOPE,
  ITEM_GROUP_SCOPE,
  ORDER_SCOPE,
  PAGE_SCOPE,
} from '../../../constants/pageModScopes';

export const PageModEntry = () => {
  const {
    pageLevelPageUxMods,
    setPageLevelPageUxMods,
    itemLevelPageUxMods,
    setItemLevelPageUxMods,
    orderLevelPageUxMods,
    setOrderLevelPageUxMods,
    itemGroupLevelPageUxMods,
    setItemGroupLevelPageUxMods,
  } = useContext(PageModsContext);
  const [newFamily, setNewFamily] = useState('');
  const [newId, setNewId] = useState('');
  const [newScope, setNewScope] = useState(ITEM_SCOPE);
  const availableScopes = [
    ITEM_SCOPE,
    PAGE_SCOPE,
    ORDER_SCOPE,
    ITEM_GROUP_SCOPE,
  ];

  const onScopeSelect = event => {
    setNewScope(event.target.value);
  };

  const handleFamilyTextInput = event => {
    const newFamilyInput = event.target.value.trim();
    if (newFamilyInput !== newFamily) {
      setNewFamily(newFamilyInput);
    }
  };

  const handleIdTextInput = event => {
    const newIdInput = event.target.value.trim();
    if (newIdInput !== newId) {
      setNewId(newIdInput);
    }
  };

  const addMod = () => {
    if (newScope === ITEM_SCOPE) {
      // add new item-level page mod
      setItemLevelPageUxMods([
        ...itemLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    if (newScope === PAGE_SCOPE) {
      // add new page-level page mod
      setPageLevelPageUxMods([
        ...pageLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    if (newScope === ORDER_SCOPE) {
      // add new order-level page mod
      setOrderLevelPageUxMods([
        ...orderLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    if (newScope === ITEM_GROUP_SCOPE) {
      // add new order-level page mod
      setItemGroupLevelPageUxMods([
        ...itemGroupLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    setNewFamily('');
    setNewId('');
    setNewScope(ITEM_SCOPE);
  };

  return (
    <TableRow>
      <TableCell>
        <TextInput
          size="mini"
          onChange={handleFamilyTextInput}
          value={newFamily}
          aria-labelledby="mod-family-label"
        />
      </TableCell>
      <TableCell>
        <TextInput
          size="mini"
          onChange={handleIdTextInput}
          value={newId}
          aria-labelledby="mod-id-label"
        />
      </TableCell>
      <TableCell id="mod-scope-label">
        <Dropdown
          size="mini"
          onChange={onScopeSelect}
          value={newScope}
          aria-labelledby="mod-scope-label"
        >
          {availableScopes.map(scope => (
            <DropdownOption value={scope} key={scope}>
              {scope}
            </DropdownOption>
          ))}
        </Dropdown>
      </TableCell>
      <TableCell>
        <Button
          buttonShape="round"
          skin="primary"
          size="mini"
          onClick={() => {
            addMod();
          }}
        >
          <Icon alt="Add mod" iconType="plus" />
        </Button>
      </TableCell>
    </TableRow>
  );
};
